export const dangers = {
  methods: {
    //TODO: 获取所有隐患类型（分页）
    async getDangersTypeall({ page, size }) {
      let res = await this.$http.get("/dangers/record/type/list", {
        pageSize: size,
        currentPage: page,
      });
      return res.data || [];
    },
    //TODO: 获取所有隐患类型（全部）
    async getDangersTypea() {
      let res = await this.$http.get("/tenant/dangers/record/type/list");
      return res || [];
    },
    //TODO: 获取隐患列表
    async getDangersTask(obj) {
      let {dangersTypeId,itemsContent, pageNum, pageSize } = obj;
      let res = await this.$http.get("/tenant/dangers/record/list",{
        dangersTypeId:dangersTypeId=='0'?null:dangersTypeId,
        itemsContent:itemsContent ?? null,
        pageNum,
        pageSize,
      });
      return res || []
    },
     //TODO: 获取隐患详细信息
     async getDangersTaskId(id) {
      let res = await this.$http.get(`/tenant/dangers/record/${id}`);
      return res || []
    },
    //TODO：新增隐患类型
    async addDangersType(obj) {
      let res = await this.$http.post("/tenant/dangers/record/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：修改隐患类型
    async upDangersType(obj) {
      let res = await this.$http.put("/tenant/dangers/record/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：根据id删除隐患类型
    async delDangersType(obj) {
      let res = await this.$http.delete(`/tenant/dangers/record/type/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：根据name查询隐患类型
    async getDangersTypeName(val) {
      let res = await this.$http.get("/dangers/getDangerstypeName", {
        name: val,
      });
      return res?.data || [];
    },
    //TODO: 修改隐患内容
    async updateDanger(obj) {
      let res = await this.$http.put("/tenant/dangers/record",obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res ;
    },
    
    //TODO : 根据隐患条目id 查询 现场照片前后
    async getdangers_items_photo(val) {
      let res = await this.$http.get("/dangers/getDangersItemPhoto", {
        id: val.id,
      });
      return res?.data || [];
    },
    //TODO: 上传/修改隐患图片
    async uploadFile(obj,type,files){
      //TODO:type(1 整改前  2 整改后) 
      let val ={
        recordId:obj.id,
        type:type
      }
      let formData = new FormData();
      Object.keys(val).forEach((keys) => {
        formData.append(keys, val[keys]);
      });
      files.forEach(async (item) => {
          formData.append("file", item.raw); 
      });
      let res = await this.$http.post("/tenant/file/dangers/record/photo", formData, {
        "Content-Type": "multipart/form-data",
      });
      //TODO:上传图片 
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO:根据图片 id 整改前/后的照片
    async delImage(file) {
     
     let obj = {
      id:file.id,
      dangersRecordId:file.dangersRecordId ?? null,
      checkRecordItemsId:file.checkRecordItemsId ?? null,
     }
      let res = await this.$http.delete(`/tenant/file/delete/photo`,obj);
      return res;
    },
    //TODO:根据图片 id 整改前的照片
    async delAfterImage(file) {
      let res = await this.$http.delete(`/tenant/file/delete/photo/${file.id}`);
      return res;
    },

    //TODO： 根据id删除隐患列表
    async delDangers(val) {
      let res = await this.$http.delete(`/tenant/dangers/record/${val.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //根据记录id修改整改负责人
    async upDangers_charge(obj, user) {
      let res = await this.$http.put("/dangers/upDangers_chargeId", {
        id: obj.id,
        dangers_charge: user.employeeid,
      });
      return res;
    },
    //根据隐患记录id去修改隐患类型
    async upDangers_type(obj) {
      let res = await this.$http.put("/dangers/upDangerstype", {
        id: obj.id,
        dangers_type: obj.dangers_type,
      });
      if (res.status == "0") {
        this.$message({ message:res.message, type: "success" });
      } else {
        this.$message.error(res.message);
      }
    },
    //TODO : 上传整改前的照片
    async addbeforePhoto(obj, arr) {

      let formData = new FormData();
      Object.keys(obj).forEach((keys) => {
        formData.append(keys, obj[keys]);
      });
      arr.forEach((file) => {
        formData.append("file", file.raw);
      });
      let res = await this.$http.post("/record/items/photo/add", formData, {
        "Content-Type": "multipart/form-data",
      });
      //TODO:上传图片 
      if (res.status == "0") {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO : 上传整改后的照片
    async addAfterPhoto(obj, arr) {

      let formData = new FormData();
      Object.keys(obj).forEach((keys) => {
        formData.append(keys, obj[keys]);
      });
      arr.forEach((file) => {
        formData.append("file", file.raw);
      });
      let res = await this.$http.post(
        "/dangers/addDangersItemPhoto",
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      );
      //TODO:上传图片
      if (res.status == "0") {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
  },
};
